<article class="search-result">
  <h1>
    <a [routerLink]="['/kokoelma', result.id]" class="text-reset">{{ result.name }}</a>
  </h1>

  <div class="row">
    <div class="col-3 col-md-2">
      <img
        [src]="result.thumbnail ? result.thumbnail : 'assets/img/thumbnails/kokoelma.png'"
        class="img-fluid mb-3"
        [alt]="'demo.educationalMaterial.cover.alt' | translate" />
    </div>
    <!--thumbnail-->

    <div class="col-9 col-md-6">
      @if (result.description) {
        <p>{{ result.description }}</p>
      }

      <ul class="list-unstyled">
        @for (author of result.authors; track author) {
          <li>{{ author }}</li>
        }
      </ul>
      <!--authors-->
    </div>

    <div class="col-12 col-md-4 text-md-end">
      <ul class="nav justify-content-md-end">
        <li class="nav-item">
          <a [routerLink]="['/kokoelma', result.id]" class="nav-link">
            <i class="fa fa-fw fa-folder-o text-dark" aria-hidden="true"></i>
            {{ "search.results.open" | translate }}
          </a>
        </li>
      </ul>
      <!--links-->

      @if (result.educationalLevels.length > 0) {
        <div class="tags">
          @for (level of result.educationalLevels; track level) {
            <button type="button" class="btn btn-light disabled" disabled>
              {{ level.value }}
            </button>
          }
        </div>
      }
      <!--keywords-->

      <div class="tags">
        @for (keyword of result.keywords; track keyword) {
          <button type="button" class="btn btn-light disabled" disabled>
            {{ keyword.value }}
          </button>
        }
      </div>
      <!--keywords-->
    </div>
  </div>
</article>
